<template>
  <div id="app">
    <TopBar />
    <router-view />
    <div
      class="developed-container"
      v-if="$route.meta.showLogo"
      :class="{ 'login-layout': $route.path === '/login' }"
    >
      <a
        id="developed-by"
        href="https://liberotratto.it/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <p>Sviluppato da</p>
        <div class="lt-logo-container">
          <img
            src="@/assets/libero_tratto_logo.png"
            alt="lt-logo"
            class="lt-logo"
          />
        </div>
      </a>
    </div>
    <ModalsContainer />
  </div>
</template>

<script>
import TopBar from "@/components/TopBar.vue"; // Percorso del componente TopBar
import { ModalsContainer } from "vue-final-modal";

export default {
  name: "App",
  components: {
    TopBar,
    ModalsContainer,
  },
};
</script>

<style src="@/css/App.css"></style>
<!-- lasciato commento testare Glitchtip -->
